import React from "react";
import styled from "styled-components";
import Typography from "../../../Foundation/Typography/Typography";
import Spinner from "../../../Foundation/Spinner/Spinner";
import Icon from "../../../Foundation/Icon/Icon";

const _CheckoutErrorRoot = styled("div")(() => {
  return {
    display: "flex",
    justifyContent: "center",
    padding: "71px 16px",
    minHeight: "80vh",
    width: 540,
    maxWidth: "100%",
    margin: "0 auto",
  };
});
const _CheckoutErrorWrapper = styled("div")<{}>(() => {
  return {
    width: "100%",
    maxWidth: 720,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 24,
  };
});

interface ICheckoutErrorProps {
  title: string;
  subtitle?: string;
  description: string;
  footer: string;
}

const CheckoutPending = (props: ICheckoutErrorProps) => {
  const { title, subtitle, description, footer } = props;
  return (
    <_CheckoutErrorRoot>
      <_CheckoutErrorWrapper>
        <Icon icon={"logo_sushi_shop"} size={96} />
        <Typography
          variant="h5"
          align="center"
          style={{ position: "relative" }}
        >
          <Spinner style={{ verticalAlign: "initial" }} /> {title}
          <br />
          {subtitle}
        </Typography>
        <Typography
          variant="subtitle2"
          align="center"
          style={{ minHeight: "6em" }}
        >
          {description}
          <br />
          {footer}
        </Typography>
      </_CheckoutErrorWrapper>
    </_CheckoutErrorRoot>
  );
};

export default CheckoutPending;
